// eslint-disable-next-line
export default new (class VideoModel {
  // static API_URL = process.env.REACT_APP_API_URL;

  async get(data) {
    const model = {};

    model.id = data.id || 0;
    model.date = data.publishedAt || "";
    model.slug = data.Slug || "";
    model.title = data.title || [];
    model.tag = data.tag || [];
    model.video = data.video || [];
    model.thumbnail = data.thumbnail || [];
    model.description = data.description || [];
    model.publisher = data.publisher || [];

    return model;
  }
})();
